import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { Modal } from '@/components/Modal'
import { useWalletStore } from '@/stores/useWalletStore'
import { useBreakpoint } from '@/hooks/useBreakpoint'
import type { WalletType } from '@/types'
import metahubLogo from '@/assets/images/metahub.svg'
import anchorIcon from '@/assets/icons/icon-anchor.svg'
import scatterIcon from '@/assets/icons/icon-ScatterSockets.svg'
import tokenpocketIcon from '@/assets/icons/icon-tokenpocket.svg'

const WEB_WALLETS: { name: string; wallet: WalletType; logo: string }[] = [
  { name: 'Metahub', wallet: 'metahub', logo: metahubLogo },
  { name: 'Scatter', wallet: 'scatter', logo: scatterIcon },
  { name: 'Anchor', wallet: 'anchor', logo: anchorIcon },
  { name: 'TokenPocket', wallet: 'tokenpocket', logo: tokenpocketIcon },
]

const MOBILE_WALLETS: { name: string; wallet: WalletType; logo: string }[] = [
  { name: 'Metahub', wallet: 'metahub', logo: metahubLogo },
  { name: 'TokenPocket', wallet: 'tokenpocket', logo: tokenpocketIcon },
]

export function LoginDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { t } = useTranslation()
  const { login } = useWalletStore()
  const { isMobile } = useBreakpoint()

  const wallets = isMobile ? MOBILE_WALLETS : WEB_WALLETS

  const handleLogin = async (wallet: WalletType) => {
    onClose()
    try {
      const account = await login(wallet)
      if (account) {
        toast.success(t('toastTip.loginSuccess'))
      }
    } catch {
      toast.error(t('error.canceled'))
    }
  }

  return (
    <Modal open={open} onClose={onClose} title={t('login.title')} className="max-w-[340px]">
      <div className="flex flex-col gap-3 mt-2">
        {wallets.map((w) => (
          <button
            key={w.wallet}
            onClick={() => handleLogin(w.wallet)}
            className="flex items-center gap-4 h-[52px] px-5 border border-[#e8e8e8] rounded-[10px] cursor-pointer hover:bg-[#f5f5f5] transition-colors outline-none focus:outline-none focus:ring-0 focus-visible:outline-none"
          >
            <img src={w.logo} alt={w.name} className="w-[28px] h-[28px]" />
            <span className="text-[15px] font-bold text-[#333]">{w.name}</span>
          </button>
        ))}
      </div>
    </Modal>
  )
}
